/// <reference path="../../Common/Base/SiteEntityGrid.ts" />

namespace Matrix.Data {
    
    @Serenity.Decorators.registerClass()
    export class SecurityGrid extends SiteEntityGrid<SecurityRow, any> {
        protected getColumnsKey() { return 'Data.Security'; }
		protected getDialogType() { return SecurityDialog; }
		protected getIdProperty() { return SecurityRow.idProperty; }
        protected getLocalTextPrefix() { return SecurityRow.localTextPrefix; }
        protected getService() { return SecurityService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getColumns() {
            var columns = super.getColumns();

            var inspect = Q.tryFirst(columns, x => x.field == "Inspect");
            if (inspect) {
                inspect.headerFilterType = Serenity.HeaderFilterType.disabled;
                inspect.format = ctx => {
                    var item = ctx.item as SecurityMergeRow;
                    if (!item.SecurityId)
                        return "";
                    return '<a class="inline-action inspect" title="Inspect"><i class="fa fa-search-plus text-blue"></i></a>';
                }
            }

            return columns;
        }

        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);

            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row) as SecurityMergeRow;
            var target = $(e.target);

            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('inspect')) {
                    new SecurityMergeInspectionDialog({
                        securityId: item.SecurityId
                    }).dialogOpen();
                }
            }
        }
    }
}